<template>
  <LayoutCard
    v-if="show"
    rounded
    :title="$t('screens.payment.legalEntities.title')"
  >
    <v-checkbox
      v-model="localValue"
      color="black"
      class="pa-0 ma-0"
      hide-details
      :ripple="false"
    >
      <template #label>
        <span class="tp-text-body-gray">
          {{ $t('screens.payment.legalEntities.checkboxLabel') }}
        </span>
      </template>
    </v-checkbox>
  </LayoutCard>
</template>

<script>
import LayoutCard from '@/components/LayoutCard.vue';

export default {
  name: 'LegalEntitiesInvoiceRequest',
  components: {
    LayoutCard,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    countryCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    functionalityNavigateToInvoiceEnabled() {
      return this.$store.getters.functionalityNavigateToInvoiceEnabled;
    },
    show() {
      return (
        this.countryCode === 'LT' && this.functionalityNavigateToInvoiceEnabled
      );
    },
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
